import React from "react";
import { Modal, Row, Col, Button } from "antd";
import styles from "./PersonModals.module.scss";
import { useWindowSize } from "../../../hooks/useWindowSize";

type Props = {
  visible: boolean;
  setVisibility: Function;
};

const PhotoUploadErrorModal: React.FC<Props> = ({ visible, setVisibility }) => {
  const { width } = useWindowSize();

  const handleContinue = () => setVisibility(false);

  return (
    <Modal
      visible={visible}
      className={styles.uploadPhotoErrorContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "547px"}
      footer={
        <Row justify="center">
          <Col>
            <Button className={styles.close} onClick={handleContinue}>
              Close
            </Button>
          </Col>
        </Row>
      }
    >
      <Row justify="center" className={styles.title}>
        Photo Upload Error
      </Row>
      <Row justify="center" gutter={[0, 20]}>
        <Col xs={3} lg={0} />
        <Col xs={18} lg={24} className={styles.description}>
          There was an error uploading your photo. Please try again.
        </Col>
        <Col xs={3} lg={0} />
        <Col
          span={24}
          className={`${styles.subDescription} ${styles.unboldText}`}
        >
          Accepted file types: JPG, JPEG, PNG
        </Col>
      </Row>
    </Modal>
  );
};

export default PhotoUploadErrorModal;
